import { InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Units } from 'Types';

type Props = {
  id?: string;
  disabled?: boolean;
  label: string;
  max?: number;
  min?: number;
  size?: number;
  value: number;
  onChange: (number: number) => void;
  fullWidth?: boolean;
  step?: number;
  shiftStep?: number;
  units?: Units | '%';
};

function NumberInput(props: Props) {
  const {
    id,
    disabled = false,
    fullWidth = true,
    label,
    max = 250,
    min = 0,
    size,
    value,
    onChange,
    step,
    units,
  } = props;

  const _onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Number(event.target.value));
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    const shiftStep = step === 1 / 8 ? 1 : 10;

    if (event.shiftKey && shiftStep != null) {
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        onChange(Math.min(max, value + shiftStep));
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        onChange(Math.max(min, value - shiftStep));
      }
    }
  };

  return (
    <TextField
      id={id}
      disabled={disabled}
      fullWidth={fullWidth}
      label={label}
      variant="outlined"
      type="number"
      inputProps={{
        step: step || 1,
        min: min,
        max: max,
        style: { minWidth: size ? 0 : 40, width: size },
      }}
      InputProps={{
        endAdornment:
          units == null ? null : (
            <InputAdornment position="end">{units}</InputAdornment>
          ),
      }}
      value={value}
      onChange={_onChange}
      onKeyDown={onKeyDown}
    />
  );
}

export default NumberInput;
